/*
 * Mega menu — ouverture au survol et état ARIA.
 *
 * Dawn définit déjà <header-menu> dans details-disclosure.js : on ne peut pas
 * le redéfinir, et éditer ce fichier reviendrait à diverger d'un asset Dawn
 * intact depuis l'import. On se contente donc d'écouteurs attachés par-dessus.
 *
 * Deux choses seulement :
 *   1. `aria-expanded` suit l'état réel du <details>. Dawn ne le met jamais à
 *      true — seul close() le pose, à false.
 *   2. Le panneau s'ouvre au survol sur desktop, avec un délai de grâce à la
 *      sortie pour que la souris puisse traverser l'espace entre l'onglet et le
 *      panneau sans le refermer en chemin.
 *
 * Le clic sur le <summary>, l'ouverture au clavier et la fermeture au focusout
 * restent entièrement gérés par Dawn.
 */
(() => {
  const CLOSE_DELAY = 150;
  const desktop = window.matchMedia('(min-width: 990px)');

  const setup = (root) => {
    root.querySelectorAll('header-menu details.mega-menu').forEach((details) => {
      if (details.dataset.mtijHover === 'true') return;
      details.dataset.mtijHover = 'true';

      const summary = details.querySelector('summary');
      if (!summary) return;

      const menu = details.closest('header-menu');
      let timer = null;

      const cancelClose = () => {
        if (timer === null) return;
        clearTimeout(timer);
        timer = null;
      };

      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');

        if (!details.open) return;

        // Un seul panneau ouvert à la fois : le survol d'un onglet voisin ne
        // doit pas empiler deux panneaux superposés.
        document.querySelectorAll('header-menu details.mega-menu[open]').forEach((other) => {
          if (other !== details) other.removeAttribute('open');
        });
      });

      menu.addEventListener('mouseenter', () => {
        if (!desktop.matches) return;
        cancelClose();
        details.setAttribute('open', '');
      });

      menu.addEventListener('mouseleave', () => {
        if (!desktop.matches) return;
        cancelClose();
        timer = setTimeout(() => {
          timer = null;
          // Le clavier a pu prendre le relais entre-temps : on ne referme pas
          // sous les pieds de quelqu'un qui tabule dans le panneau.
          if (menu.contains(document.activeElement)) return;
          details.removeAttribute('open');
        }, CLOSE_DELAY);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setup(document));
  } else {
    setup(document);
  }

  // L'éditeur de thème remplace l'en-tête entier à chaque modification.
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
